import * as React from 'react';
import { FC } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import { BaseRadioButtonsProps } from '../types/global';
import ElementDescription from './ElementDescription';
import { checkFeatureFieldEnabled } from '../helpers/configuration';

const BaseRadioButtons: FC<BaseRadioButtonsProps> = ({
  value,
  name,
  label,
  onChange,
  isDisabled,
  items,
  errors,
  required,
  feature = null,
}) => {
  if (name && feature && !checkFeatureFieldEnabled(feature, name)) {
    return null;
  }

  return (
    <FormControl
      fullWidth
      error={!!errors?.[name]}
      required={required || false}
    >
      <FormLabel id='radio-group-label'>{label}</FormLabel>
      <RadioGroup
        row
        aria-labelledby='radio-group-label'
        value={value}
        name={name}
        onChange={onChange}
      >
        {items.map((item) => (
          <FormControlLabel
            key={item.value || item}
            value={item.value || item}
            name={name}
            control={
              <Radio
                disabled={
                  (isDisabled && isDisabled(item.value || item)) || false
                }
              />
            }
            label={item.label || item}
          />
        ))}
      </RadioGroup>
      {!!errors?.[name] ? (
        <ElementDescription error={true}>{errors?.[name]}</ElementDescription>
      ) : null}
    </FormControl>
  );
};

export default BaseRadioButtons;
